export const TRANSACTIONS_HISTORY_PATH = '/transactions';
export const TRANSACTIONS_SUMMARY_PATH = '/transactions/summary';
